// The build's git SHA, injected by Vite (`define.__APP_VERSION__`, see
// vite.config.ts). Single client-side accessor — used for the discreet on-screen
// stamp, the app_opened analytics property, and the stale-bundle check
// (useVersionCheck compares this to /version.json).

declare const __APP_VERSION__: string;

// Guarded: vitest doesn't run Vite's `define`, so the symbol is absent under test.
export const APP_VERSION: string =
  typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "dev";
